<div id="about" class="about-area">
    <div class="container">
        <div class="section-title">
            <h2>Sobre el <span>CIDHUM</span></h2>
            <p>El Centro de Investigaciones en Desarrollo Humano (CIDHUM) fue creado el 26 de marzo de 1996.</p>

        </div>
        <div class="row align-items-start">
            <div class="col-lg-6 col-md-12 order-lg-2">
                <div class="about-content">
                    <div class="section-title">
                        <!--<h2>We Are Digital <span>Marketing & Branding</span></h2>-->
                        <p>El CIDHUM se fundó con el objetivo de
                            realizar investigaciones para generar nuevos conocimientos científicos a través
                            de cinco líneas de investigación.</p> <br>
                        <p>Al mismo tiempo, desarrolla proyectos y programas experimentales de investigación desde
                            la Región Caribe para contribuir a la política pública y al mejoramiento de la calidad
                            de vida de las poblaciones que viven en contextos adversos.</p>

                    </div>
                    <!--<ul class="features-list">
                        <li><i class="fas fa-check"></i>Investigaciones destacables sobre la infancia en contextos
                            adversos, las cuales se remontan al año 1977.</li>
                        <li><i class="fas fa-check"></i>Participó en dos convocatorias de Reconocimiento
                            de Centros en 1996 y el 2000.</li>
                        <li><i class="fas fa-check"></i>En 2011 participó en la elaboración de documentos
                            para la política dirigida a niñez de <b>Cero a Siempre</b>.</li>
                        <li><i class="fas fa-check"></i>En 2019 Minciencias otorgó a este centro el título de <b>Centro
                                de Investigaciones del Sistema Nacional de Ciencia, Tecnología e Innovación</b></li>
                        <li><i class="fas fa-check"></i>Modern Design</li>
                        <li><i class="fas fa-check"></i>Awesome Design</li>
                        <li><i class="fas fa-check"></i>Digital Marketing & Branding</li>
                    </ul>-->
                </div>
            </div>
            <div class="col-lg-6 col-md-12 order-lg-1">
                <div class="about-video">
                    <img src="assets/img/about.jpeg" alt="about" loading="lazy">
                    <div class="video-btn">
                        <!-- <button class="popup-youtube" (click)="ngxSmartModalService.getModal('popupOne').open()"><i class="fas fa-play"></i></button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="video-popup">
    <!-- <ngx-smart-modal #popupOne [identifier]="'popupOne'">
        <iframe src="https://www.youtube.com/embed/WQ119jAN4Xo" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </ngx-smart-modal> -->
</div>
